/** @import Address from '@/classes/facturae/Address' */
/** @import ContactDetails from '@/classes/facturae/ContactDetails' */
/** @import AdminsitrativeCentre from '@/classes/facturae/AdminsitrativeCentre' */
/** @import FACeB2BIdentificatives from '@/classes/facturae/FACeB2BIdentificatives' */
/** @import AdminsitrativeCentreFACeB2B from '@/classes/facturae/AdminsitrativeCentreFACeB2B' */
/** @import RegistrationData from '@/classes/facturae/RegistrationData' */
export default class Assignee {
  /** @type {number?} */ IdSociedad = null
  /** @type {number?} */ IdSede = null
  
  /** @type {string?} */ TIN = null
  /** @type {string?} */ ResidenceType = null
  /** @type {string?} */ PersonType = null
  /** @type {string?} */ CorporateName = null
  /** @type {string?} */ PersonName = null
  /** @type {string?} */ FirstSurname = null
  /** @type {string?} */ SecondSurname = null
  
  /** @type {Address?} */ Address = null
  /** @type {ContactDetails?} */ ContactDetails = null
  /** @type {RegistrationData?} */ RegistrationData = null
}
